import { ReviewsMinimal } from "@jog/types"

export const getReviews = async (productName: string) => {
    const response = await fetch(`/api/getReviews?productName=${productName}`, { method: "GET" })
    return (await response.json()) as ReviewsMinimal
}
